module.exports = __webpack_public_path__ + "img/Vikinger.c9092513.svg";